import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppService {
    constructor(private router: Router) {}

    isViewerShown(): boolean {
        const indexEnd = this.router.url.indexOf('/', 1);
        const currentPath = this.router.url.substring(0, indexEnd);
        const validPaths: string[] = ['/viewer', '/scan-viewer', '/site-viewer'];
        return validPaths.includes(currentPath);
    }

    isHome(): boolean {
        return this.router.url.indexOf('/home') >= 0;
    }
}
